import honoringGold from "@/assets/honoringGold.svg";
import { Button } from "../ui/button";
import { toPng } from "html-to-image";
import { useRef } from "react";
import { useTranslation } from "react-i18next";
import { CertificateCohLogo } from "@/assets/CertificateCohLogo";
import { CertificateArCohLogo } from "@/assets/CertificateArCohLogo";
import { Frame } from "@/assets/Frame";

export const DigitalCertificate = ({
  honoreeName,
  fullName,
}: {
  honoreeName: string;
  fullName: string;
}) => {
  const certRef = useRef<HTMLDivElement>(null);
  const { t, i18n } = useTranslation();
  const certicateInfo = {
    dontation_date: new Date().toLocaleDateString(i18n.language, {
      year: "numeric",
      month: "long",
      day: "numeric",
    }),
  };

  const handleDownload = async () => {
    if (!certRef.current) {
      return;
    }

    const dataUrl = await toPng(certRef.current, { cacheBust: true });

    const link = document.createElement("a");
    link.download = "certificate.png";
    link.href = dataUrl;
    link.click();
  };
  return (
    <>
      <div
        className="relative  mb-3 h-[304px] w-[380px] rounded-2xl bg-[#E2DDD7] p-6 lg:h-[282px] lg:w-[615px]"
        ref={certRef}
      >
        <Frame />
        <div className="relative z-auto">
          <div className=" mb-4 flex items-center justify-between">
            {i18n.language === "ar" ? <CertificateArCohLogo /> : <CertificateCohLogo />}
            <p className="text-sm font-350 leading-[140%]">
              {t("toIntlDate", { value: certicateInfo.dontation_date, dateStyle: "long" })}
            </p>
          </div>
          <div className="mb-4 flex items-center justify-center gap-2">
            <h2 className="text-xl font-650 leading-[127%] lg:text-2xl">
              {t("paymentState.honoringYour")}
            </h2>
            <img src={honoringGold} alt="" />
            <h2 className="text-xl font-650 leading-[127%] lg:text-2xl">
              {t("paymentState.heartOfGold")}
            </h2>
          </div>
          <p className="mb-4 border-b-2 border-[#D7D0CB] pb-4 text-center text-base font-350 leading-[140%]">
            {t("paymentState.donationMadeBy")} <span className="font-650">{fullName}</span>{" "}
            {t("paymentState.honorOf")} <span className="font-650">{honoreeName}</span>
          </p>
          <p className="text-center text-sm font-350 leading-[140%] lg:text-base">
            {t("paymentState.donationAcknowledge")}
          </p>
        </div>
      </div>

      <Button className="w-full px-10 py-6 font-bold lg:w-auto" onClick={handleDownload}>
        {t("paymentState.downloadCertificate")}
      </Button>
    </>
  );
};
